import PropTypes from 'prop-types';
import * as LucideIcons from 'lucide-react';
import { cn } from '@/common-utils/libraries/tailwind/utils';

/**
 * @param root0
 * @param root0.className
 * @param root0.icon
 * @param root0.verticalAlignWithText
 * @param root0.size
 * @param root0.strokeWidth
 * @param root0.filled
 * @returns {JSX} Icon
 */
function Icon({
    className,
    icon,
    verticalAlignWithText,
    size = 20,
    strokeWidth = 2,
    filled = false,
    ...props
}) {
    const LucideIcon = LucideIcons[icon];

    if (!LucideIcon) {
        return null;
    }

    return (
        <LucideIcon
            className={cn(
                'lucide',
                filled && 'fill-current',
                verticalAlignWithText && 'align-middle',
                className
            )}
            size={size}
            strokeWidth={strokeWidth}
            data-cy={`icon-${icon}`
            }
            {...props}
        />
    );
}

Icon.propTypes = {
    icon: PropTypes.string,
    className: PropTypes.string,
    verticalAlignWithText: PropTypes.bool,
    size: PropTypes.number,
    strokeWidth: PropTypes.number,
    filled: PropTypes.bool
};

export default Icon;